export default __webpack_public_path__ + "static/delivery-presentation_kz-7f9c7b60877448970b5e05b0061428f6.png";